export default __webpack_public_path__ + "static/media/about8.17ba6815.jpeg";